import React from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import InputBase from "@material-ui/core/InputBase";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Chip from "@material-ui/core/Chip";
import styled from "styled-components";

const BorderLessInput = withStyles((theme) => ({
  root: {
    margin: 0,
    "label + &": {
      marginTop: theme.spacing(3),
      fontSize: 20,
    },
  },
  input: {
    position: "relative",
    border: "0",
    fontSize: 14,
    padding: "10px 26px 10px 2px",
    transition: theme.transitions.create(["margin-top"]),
    color: theme.palette.text.secondary,
    "&:focus": {
      borderRadius: 4,
      borderColor: theme.palette.background.main,
      backgroundColor: theme.palette.background.main,
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
    maxWidth: 300,
  },
}));

export const MultiSelect = ({
  label,
  placeholder,
  selectedList,
  optionList,
  onChange,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <FormControl className={classes.formControl}>
      <Label id={`custom-select-${label}`} shrink theme={theme}>
        {label}
      </Label>

      <Select
        labelId={`custom-select-${label}`}
        autoWidth
        displayEmpty
        multiple
        value={selectedList}
        onChange={(event) => onChange(event.target.value)}
        input={<BorderLessInput />}
        renderValue={(selected) => (
          <div className={classes.chips}>
            {selected && selected.length === 0 ? (
              <span>{placeholder}</span>
            ) : (
              selected?.map((value, index) => {
                if (index < 2)
                  return (
                    <Chip key={value} label={value} className={classes.chip} />
                  );
                if (index === 2)
                  return (
                    <Chip key={value} label={"..."} className={classes.chip} />
                  );
                return null;
              })
            )}
          </div>
        )}
        inputProps={{ "aria-label": "Without label" }}
      >
        <MenuItem disabled value="">
          <em>{placeholder}</em>
        </MenuItem>
        {optionList.map(({ label, value }) => (
          <MenuItem
            key={value}
            value={value}
            // style={getStyles(name, personName, theme)}
          >
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const Label = styled(InputLabel)`
  color: ${(props) => props.theme.palette.text.primary} !important;
  font-size: 13pt;
  font-weight: bold;
  line-height: 14px;
  margin-top: 10px;
`;
